import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ["add", "addhere", "template", "choosebtn", "chooseinput", "valueinput", "nestedcount"]

  add_association(event, count=1) {
    event.preventDefault()
    let content = ""

    if (this.hasNestedcountTarget && this.nestedcountTarget.value) {
      count = this.nestedcountTarget.value
    }

    for (let i = 0; i < count; i++) {
      let id = `${new Date().valueOf()}${i}`
      content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, id)
      this.addhereTarget.insertAdjacentHTML('beforebegin', content) 
    }
  }

  remove_association(event) {
    event.preventDefault()
    let item = event.currentTarget.closest(".nested-fields")
    item.querySelector("input[name*='_destroy']").value = 1
    item.style.display = 'none'
  }

  destroy_association(event) {
    event.preventDefault()
    let item = event.currentTarget.closest(".nested-fields")
    item.remove()
  }

  refresh_association(event) {
    event.preventDefault()
    event.currentTarget.closest('a').classList.add('disabled')
    let icon_element = event.currentTarget.tagName == 'I' ? event.currentTarget : event.currentTarget.querySelector('i')
    icon_element.classList = ['fas fa-check']
    let item = event.currentTarget.closest(".nested-fields")
    let refresh_input = item.querySelector("input[name*='_refresh']")
    refresh_input.value = 1
  }

  clear_association(event) {
    event.preventDefault()
    event.currentTarget.closest('a').classList.add('disabled')
    let icon_element = event.currentTarget.tagName == 'I' ? event.currentTarget : event.currentTarget.querySelector('i')
    icon_element.classList = ['fas fa-check']
    let item = event.currentTarget.closest(".nested-fields")
    let refresh_input = item.querySelector("input[name*='_clear']")
    refresh_input.value = 1
  }

  choose_trigger(event) {
    this.choosebtnTargets.forEach((el) => {
      if (el.dataset.id == event.currentTarget.dataset.id) {
        let regex=/^[a-zA-Z]+$/

        if (event.currentTarget.value && !event.currentTarget.value.match(regex)) {
          this.choose_row_by(el, true)
        }

        if (event.currentTarget.value == '' || event.currentTarget.value == null) {
          this.choose_row_by(el, false, true)
        }

      }
    })
  }

  choose_row(event) {
    event.preventDefault()
    this.choose_row_by(event.currentTarget)
  }

  choose_row_and_submit(event) {
    event.preventDefault()
    this.chooseinputTargets.forEach((el) => {
      if (event.currentTarget.dataset.id == el.dataset.id) {
        el.value = '1'
      } else {
        el.value = ''
      }
    })

    this.valueinputTargets.forEach((el) => {
      if (event.currentTarget.dataset.id == el.dataset.id) {
        el.value = event.currentTarget.dataset.valueid
      } else {
        el.value = ''
      }
    })

    let formObj = $(event.currentTarget).closest('form')
    formObj.append(`<input type="hidden" name="service_name" value="${event.currentTarget.dataset.serviceName}" />`)
    formObj.append(`<input type="hidden" name="action_after_update" value="${event.currentTarget.dataset.actionAfterUpdate}" />`)
    Rails.fire(formObj[0], 'submit')
  }

  choose_row_by(target, force, clear = false) {
    let checked_class_list = ['fas fa-check']

    this.choosebtnTargets.forEach((el) => {
      let icon_element = el.tagName == 'I' ? el : el.querySelector('i')
      icon_element.classList = [el.dataset.icon]

      this.chooseinputTargets.forEach((input_el) => {

        if (el.dataset.id == input_el.dataset.id) {
          if (el == target) {
            if (clear) {
              input_el.value = null
            } else if (input_el.value != '1' || force) {
              input_el.value = '1'
              icon_element.classList = checked_class_list
            } else {
              input_el.value = null
            }
          } else {
            input_el.value = null
          }
        }
      })

    })
  }

}
